<template>
  <div class="plan-card-discovery-component
    w-full
    bg-white/90
    p-6
    text-black">
    <h3 class="text-sm
      font-semibold
      text-[#000000]
      text-center
      mb-0
      mt-4">{{$t('planCard.bestforGettingStarted')}}</h3>

    <h1 class="text-3xl
      font-black
      text-[#000000]
      uppercase
      text-center
      mt-3">{{$t('planCard.discovery')}}</h1>

    <h1 class="text-3xl
      font-black
      text-[#23569F]
      uppercase
      text-center
      mt-3">{{$t('planCard.free')}}</h1>

    <ul class="main-features mt-10 w-[189px] mx-auto">
      <li v-for="(item, index) in mainFeatures" :key="index"
        class="p-3
          text-xs
          px-0
          border-b
          border-white
          last:border-b-0
          font-semibold
          text-left">{{item}}</li>
    </ul>

    <div class="text-sm
        font-sm
        text-[#000000]
        uppercase
        text-center
        mt-12
        font-semibold">{{$t('planCard.yourPlan')}}</div>
  </div>
</template>

<script src="./plan-card-discovery.js"></script>
<style type="text/scss" lang="scss" scoped>
@reference '#tailwind.scss';
</style>
